import React from 'react';
import useStyles from './Footer.styles';
import HelpIcon from '../icons/HelpIcon';

const Footer = () => {
  const classes = useStyles();

  return (
    <footer className={classes.root}>
      <div>v1.13.0</div>
      <a href="/help">
        <HelpIcon />
      </a>
    </footer>
  );
};
export default React.memo(Footer);
